export default {
      id: "t_id-usage",
      viewBox: "0 0 37 20",
      url: __webpack_public_path__ + "svgsprite.svg#t_id",
      toString: function () {
        return this.url;
      }
    }